import { createFileRoute } from '@tanstack/react-router';
import type { JSX } from 'react';

import CustomerDetailsPage from '@/areas/customers/Customers/CustomerDetailsPage';
import { canViewCustomers } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/next/customers/$customerId')({
    staticData: { access: { permissions: canViewCustomers }, chrome: 'none' } satisfies PageStaticData,
    component: RouteComponent,
    // Otherwise an open invite dialog follows the user Back to another customer.
    remountDeps: ({ params }) => params.customerId,
});

function RouteComponent(): JSX.Element {
    const pathParams = Route.useParams();
    return <CustomerDetailsPage {...pathParams} />;
}
